import { render, staticRenderFns } from "./Target.vue?vue&type=template&id=6e0b5723&scoped=true&"
import script from "./Target.vue?vue&type=script&lang=js&"
export * from "./Target.vue?vue&type=script&lang=js&"
import style0 from "./Target.vue?vue&type=style&index=0&id=6e0b5723&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0b5723",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e0b5723')) {
      api.createRecord('6e0b5723', component.options)
    } else {
      api.reload('6e0b5723', component.options)
    }
    module.hot.accept("./Target.vue?vue&type=template&id=6e0b5723&scoped=true&", function () {
      api.rerender('6e0b5723', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/components/Target.vue"
export default component.exports